const NAVIGATIONS_LIST = [
  {
    label: 'containers.manage.nvbugs.nvbugsCard.title',
    to: 'NVBugs Projects Association'
  }
]

const NVBUGS = 'fulcrum/container/Manage/Nvbugs/Nvbugs'
const MOUNT = 'fulcrum/container/Manage/Nvbugs/Nvbugs/MOUNT'
const UNMOUNT = 'fulcrum/container/Manage/Nvbugs/Nvbugs/UNMOUNT'

export {
  NVBUGS,
  MOUNT,
  UNMOUNT,
  NAVIGATIONS_LIST,
}
